// js/custom-element/section/cart/shipping-estimator.js
(function() {
  const init = function() {
    if (!window.customElements.get("shipping-estimator")) {
      var ShippingEstimator = class extends HTMLElement {
        connectedCallback() {
          this.submitButton = this.querySelector('[type="button"]');
          this.submitButton.addEventListener("click", this._estimateShipping.bind(this));
        }
        async _estimateShipping() {
          const zip = this.querySelector('[name="shipping-estimator[zip]"]').value, country = this.querySelector('[name="shipping-estimator[country]"]').value, province = this.querySelector('[name="shipping-estimator[province]"]').value;
          this.submitButton.setAttribute("aria-busy", "true");
          const prepareResponse = await fetch(`${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
          if (prepareResponse.ok) {
            const shippingRates = await this._getAsyncShippingRates(zip, country, province);
            this._formatShippingRates(shippingRates);
          } else {
            const jsonError = await prepareResponse.json();
            this._formatError(jsonError);
          }
          this.submitButton.removeAttribute("aria-busy");
        }
        async _getAsyncShippingRates(zip, country, province) {
          const response = await fetch(`${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
          const responseAsText = await response.text();
          if (responseAsText === "null") {
            return this._getAsyncShippingRates(zip, country, province);
          } else {
            return JSON.parse(responseAsText)["shipping_rates"];
          }
        }
        _formatShippingRates(shippingRates) {
          var _a;
          (_a = this.querySelector(".shipping-estimator__results")) == null ? void 0 : _a.remove();
          let formattedShippingRates = "";
          shippingRates.forEach((shippingRate) => {
            formattedShippingRates += `<li>${shippingRate["presentment_name"]}: ${window.formatMoney(parseFloat(shippingRate["price"]) * 100)}</li>`;
          });
          const html = `
          <div class="shipping-estimator__results">
            <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
            ${formattedShippingRates === "" ? "" : `<ul class="unordered-list">${formattedShippingRates}</ul>`}
          </div>
        `;
          this.insertAdjacentHTML("beforeend", html);
        }
        _formatError(errors) {
          var _a;
          (_a = this.querySelector(".shipping-estimator__results")) == null ? void 0 : _a.remove();
          let formattedShippingRates = "";
          Object.keys(errors).forEach((errorKey) => {
            formattedShippingRates += `<li>${errorKey} ${errors[errorKey]}</li>`;
          });
          const html = `
          <div class="shipping-estimator__results">
            <p>${window.themeVariables.strings.shippingEstimatorError}</p>
            <ul class="unordered-list">${formattedShippingRates}</ul>
          </div>
        `;
          this.insertAdjacentHTML("beforeend", html);
        }
      };
      window.customElements.define("shipping-estimator", ShippingEstimator);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();